'use client'

import {
  Anchor,
  H1,
  H2,
  H3,
  Image,
  Paragraph,
  Separator,
  Sheet,
  XStack,
  YStack,
} from 'tamagui'
import React, { useState } from 'react'
import { Text } from '@tamagui/web'
import { useDataStore } from '@/contexts/DataStoreContext'
import { Button } from './common/Button';

export function ErrorState() {

  const { session: { error } } = useDataStore()

  const expired = error?.response?.data?.expired
  const invalid = error?.message === 'Missing auth URL param'

  let title
  let body 
  let button 
  
  if (expired) {
    title = <Text>Link expired 😪</Text>
    body = <Text>The link you opened was sent over 1 hour ago, and it's no longer valid.<br/>To continue, please give us a call again at 833-984-2291 and use your keypad to request your card PIN to be changed.</Text>
    button = <Anchor href="tel://+18339842291" target="_blank"><Button>Call Extra</Button></Anchor>
  }
  else if (invalid) {
    title = <Text>Welcome! 👋</Text>
    body = <Text>To change your Extra card PIN, please give us a call at 833-984-2291 and use your keypad to request your PIN to be changed.<br/>We'll then text you a personalized secure link to manage your card.</Text>
    button = <Anchor href="tel://+18339842291" target="_blank"><Button>Call Extra</Button></Anchor>
  }
  else {
    title = <Text>Something went wrong 😢</Text>
    body = <Text>Please send us an email at hey@extra.app and we'll assist you further.</Text>
    button = <Anchor href="mailto:hey@extra.app" target="_blank"><Button>Email Extra Concierge</Button></Anchor>
  }

  return (
    <YStack justifyContent='center' alignItems='center' flex={1} p={0}>
      <YStack space={40} w="100%" maxWidth="600px">
        <XStack alignItems='center' justifyContent='center' space="$2">
          <H3 textAlign="center">
            {title}
          </H3>
        </XStack>
        <Paragraph textAlign="center">
          {body}
        </Paragraph>

        <Separator />
      
        {button &&
          <XStack justifyContent='center'>
            {button}
          </XStack>
        }

      </YStack>

    </YStack>
  )
}
